<template>
  <div class="sp">
    <div class="sp-brew" :style="{ width: scrollProgress + '%' }"></div>

    <header class="sp-nav" :class="{ 'sp-scrolled': scrolled }">
      <a class="sp-lockup" @click="$router.push('/')">
        <img src="../assets/tcb-cup.png" alt="The Coffee Break cup logo" />
        <span>The Coffee Break</span>
      </a>
      <div class="sp-nav-actions">
        <div class="sp-menu-wrap" ref="menuWrap">
          <button
            class="sp-menu-btn"
            @click="menuOpen = !menuOpen"
            :aria-expanded="menuOpen"
          >
            Menu
          </button>
          <div class="sp-menu-dropdown" :class="{ 'sp-menu-open': menuOpen }">
            <a @click="goto('/')">Home</a>
            <a @click="goto('/about')">About</a>
            <a @click="goto('/career')">Career</a>
            <a @click="goto('/privacy-policy')">Privacy Policy</a>
            <a @click="goto('/ilovetcb')">
              <svg class="sp-heart" viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden="true">
                <path
                  d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                ></path>
              </svg>
              Support Us
            </a>
          </div>
        </div>
        <button class="sp-cta" @click="focusFinalEmail">Subscribe — Free</button>
      </div>
    </header>

    <main>
      <section class="ab-legal-hero">
        <div class="sp-wrap">
          <div class="sp-kicker" v-reveal>Legal</div>
          <h1 class="sp-display ab-legal-title">
            <span class="sp-row"><span>Terms of</span></span>
            <span class="sp-row"><span><em class="sp-cupword">Service.</em></span></span>
          </h1>
        </div>
      </section>

      <section class="ab-legal">
        <div class="sp-wrap ab-legal-wrap" v-reveal>
          Finlit Media Tech Group Sdn Bhd. (“FMTG” or “we”, “our” or “us”) operates The Coffee
          Break services, which includes a newsletter and a website (collectively, the
          “Services”).
          <br /><br />
          These Terms of Service form part of the overall “Agreement” between you and us, which
          also includes:
          <br />
          (1) our Privacy Policy, which explains how we collect and use your information; and
          <br />
          (2) our Shipping, Refunds and Returns Policy, which applies to your subscription
          payment
          <br /><br />
          By using the Services, you agree to be bound by this Agreement.
          <br /><br />
          We may modify this Agreement from time to time and such modification will be
          effective upon posting on the Services. You will be deemed to have agreed to any such
          modifications by your further use of the Services after any such modification is
          posted. It is therefore important that you review this Agreement regularly to ensure
          you are updated as to any changes. If you do not agree with the modifications, please
          discontinue use of the Services immediately.
          <br /><br />

          <h5>1. CONTENT</h5>
          <b>Proprietary Rights</b><br />

          With the exception of content posted by users of the Services (“User Content”), all
          materials contained on the Services, including all content, and the sound, audio,
          software, graphics, text and look and feel of the Services, and all trademarks,
          copyrights, patents and other intellectual property rights related thereto
          (“Proprietary Materials”), are owned or controlled by FMTG, our subsidiaries or
          affiliated companies, contributors, our third party licensors, and/or our advertising
          partners. You may not modify, remove, delete, augment, add to, publish, transmit,
          participate in the transfer or sale of, create derivative works from, or in any way
          exploit any Proprietary Materials, or any other protectable aspects of the Services,
          in whole or in part, unless specifically stated otherwise. Subject to your compliance
          with this Agreement and any other relevant policies related to the Services, we grant
          you a non-exclusive, non-transferable, revocable limited license, subject to the
          limitations herein, to access and use the Services and Proprietary Materials for your
          own non-commercial entertainment purposes consistent with the intended purpose of the
          Services. You agree not to use the Services for any other purpose.
          <br /><br />
          You may be able to post, upload, or submit content to be made available through the
          Services (“Your Content”). As a condition of your use of the Services, you grant us a
          nonexclusive, perpetual, irrevocable, royalty-free, worldwide, transferable,
          sublicenseable license to access, use, host, cache, store, reproduce, transmit,
          display, publish, distribute, modify and adapt and create derivative works (either
          alone or as part of a collective work) from Your Content. You also agree that (a) the
          other users of the Services shall have the right to comment on and/or tag Your Content
          and/or to use, publish, display, modify or include a copy of Your Content as part of
          their own use of the Services, and (b) we have the right to make any of Your Content
          available to third parties, so that those third parties can distribute, make
          derivative works of, comment on and/or analyze your Content on other media and
          services (either alone or as part of a collective work). By posting or submitting Your
          Content through the Services, you represent and warrant that you have, or have
          obtained, all rights, licenses, consents, permissions, power and/or authority
          necessary to grant the rights granted herein for Your Content. You agree that Your
          Content will not contain material subject to copyright or other proprietary rights,
          unless you have the necessary permission or are otherwise legally entitled to post the
          material and to grant us the license described above.
          <br /><br />
          <b>Third-Party Content &amp; User Content</b><br />
          You acknowledge that the Services may include content provided by users. Any opinions,
          advice, statements, judgments, services, offers, or other information that constitutes
          part of the content expressed or made available by third parties, including content
          posted by our contributors or User Content, are those of the respective authors and
          not of FMTG or its affiliates or any of their officers, directors, employees, or
          agents. While we retain the right to filter or reject User Content and other content
          posted by third parties, we review User Content and other third party content in a
          limited gate-keeper fashion and have no obligation to investigate whether any content
          or other User Content violate any term of this Agreement and will not do so in most
          cases. We neither endorse nor are responsible for the User Content or any other
          content posted to the Services by anyone other than FMTG.
          <br /><br />
          Just as you retain complete ownership of Your Content (subject to the license to us
          granted above), all other users of the Services retain ownership of their User
          Content. You may not modify, remove, delete, augment, add to, publish, transmit,
          participate in the transfer or sale of, create derivative works from, or in any way
          exploit any User Content in whole or in part.
          <br /><br />
          <h5>2. CONDUCT</h5>
          You, as a user, agree to use the Services only for lawful purposes. Without limiting
          anything else above, specific prohibited activities include, but are not limited
          to:<br />
          <ul>
            <li>
              depicting, encouraging or partaking in criminal or tortious activity, including
              fraud, trafficking in obscene or illegal material, drug dealing or using, underage
              drinking, gambling, violence, harassment, stalking, spamming, spimming, sending of
              viruses or other harmful files,
            </li>
            <li>
              depicting, encouraging or partaking in dangerous activities or conduct that is
              abusive, threatening, obscene, defamatory or libelous;
            </li>
            <li>
              posting, uploading or sharing content that violates any of the prohibitions herein
              or that constitutes copyright infringement, patent infringement, or theft of trade
              secrets;
            </li>
            <li>
              attempting to circumvent, disable or otherwise interfere with security-related
              features of the Services or features that prevent or restrict use or copying of
              any content or enforce limitations on use of the Services or the content therein;
            </li>
            <li>
              using any software that intercepts, mines, or otherwise collects information about
              other users or copies and stores any Proprietary Materials (as defined below);
            </li>
            <li>
              interfering with, disrupting, or creating an undue burden on the Services or the
              networks or services connected to the Services;
            </li>
            <li>attempting to impersonate another user or person;</li>
            <li>soliciting personal information from anyone under 18;</li>
            <li>
              collecting, harvesting, soliciting or posting personally identifiable information
              about anyone other than yourself;
            </li>
            <li>
              using information obtained from the Services in order to harass, abuse, or harm
              another person, whether a user or a contributor;
            </li>
            <li>using the Services a commercial manner.</li>
          </ul>
          <br />
          You represent and warrant that neither your actions on the Services nor Your Content
          will violate any of the prohibited conduct described above.
          <br /><br />
          <h5>3. LINKS</h5>
          The Services may contain links or otherwise direct you to websites operated by third
          parties. We do not monitor or control the linked sites and make no representations
          regarding, and are not liable or responsible for the accuracy, completeness,
          timeliness, reliability or availability of, any of the content uploaded, displayed, or
          distributed, or products, or services available at these sites. If you choose to
          access any third party site, you do so at your own risk. The presence of a link to a
          third party site does not constitute or imply our endorsement, sponsorship, or
          recommendation of the third party or of the content, products, or services contained
          on, or available through, the third party site.
          <br /><br />
          We reserve the right to disable links to third party sites.
          <br /><br />

          <h5>4. CERTAIN SERVICES</h5>
          <b>Subscription</b><br />
          Payment. You acknowledge and agree that all information you provide with regards to a
          purchase of Offerings, including, without limitation, credit card, PayPal, or other
          payment information, is accurate, current and complete. You represent and warrant that
          you have the legal right to use the payment method you provide to us or our payment
          processor, including, without limitation, any credit card you provide when completing
          a transaction. To the extent that we are required by law to charge and collect taxes
          on Offerings, such taxes are charged based on the tax laws applicable to the location
          to which the order is being shipped or delivered. At checkout, all appropriate taxes
          will be added to the order total. The tax amount displayed during checkout is an
          estimate. This amount may vary slightly from the actual amount of tax payable in
          connection with your order due to different tax rates which apply as a result of the
          origin and destination of the item(s) being purchased, as well as other factors. When
          you purchase Offerings, you (a) agree to pay the price for such Offerings as set forth
          in the applicable Service, and all shipping and handling charges and all applicable
          taxes in connection with your purchase (the “Full Purchase Amount”), and (b) authorize
          us to charge your credit card or other payment method for the Full Purchase Amount.
          Unless otherwise noted, all currency references are in U.S. Dollars. All fees and
          charges are payable in accordance with payment terms in effect at the time the fee or
          the charge becomes payable. Payment can be made by credit card, debit card, or through
          PayPal or other means that we may make available. Orders will not be processed until
          payment has been received in full, and any holds on your account by any payment
          processor are solely your responsibility.
          <br />
          <b>Special Promotions</b><br />
          We may offer you the chance to participate in drawings, contests, giveaways, and
          promotions (“Special Promotions”) through the Services. By registering for a Special
          Promotion, you agree to the official rules that govern that Special Promotion, which
          may contain specific requirements of you, including, except where prohibited by law,
          allowing the sponsor(s) of the Special Promotion to use your name, voice and/or
          likeness in advertising or marketing associated with the Special Promotion. If you
          choose to enter a drawing, contest or other promotion, personally identifiable
          information may be disclosed to third parties or the public in connection with the
          administration of such Special Promotion, including, without limitation, in connection
          with winner selection, prize fulfillment, and as required by law or permitted by the
          Special Promotion’s official rules, such as on a winners list.
          <br /><br />
          <h5>5. THIRD-PARTY COMPANIES AND PROVIDERS</h5>
          The Services may enable you to request and receive products, information and services
          from businesses that are not owned or operated by us. The purchase, payment, warranty,
          guarantee, delivery, maintenance, and all other matters concerning the merchandise,
          services or information, opinion or advice ordered or received from such businesses
          are solely between you and such businesses. We do not endorse, warrant, or guarantee
          such products, information, or services, and are not liable for the accuracy,
          completeness, or usefulness of such information or the quality of availability of such
          products or services. We will not be a party to or in any way be responsible for
          monitoring any transaction between you and third-party providers of such products,
          services, or information, or for ensuring the confidentiality of your credit card
          information. Any separate charges or obligations you incur in your dealings with these
          third parties are your responsibility and are not part of the fee, if any, charged for
          the Services.
          <br /><br />
          In addition, the Services may prompt you to establish an account with a third party
          service provider not owned or operated by us. Your agreement and understanding with
          any such third party service provider is solely between you and such service provider.
          Any disputes you may encounter with such third party service provider must be settled
          solely between you and the service provider.
          <br /><br />

          <h5>6. DISCLAIMERS AND LIMITATION OF LIABILITY</h5>
          THE SERVICES ARE PROVIDED BY US ON AN "AS IS" AND "AS AVAILABLE" BASIS. TO THE
          FULLEST EXTENT PERMISSIBLE BY APPLICABLE LAW, WE DISCLAIM ALL IMPLIED WARRANTIES,
          INCLUDING BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
          PARTICULAR PURPOSE.<br />
          WITHOUT LIMITING THE FOREGOING, NEITHER WE NOR ANY THIRD-PARTY PROVIDER MAKES ANY
          REPRESENTATION OR WARRANTY OF ANY KIND, EXPRESS OR IMPLIED: (I) AS TO THE OPERATION OF
          THE SERVICES, OR THE INFORMATION, CONTENT, MATERIALS OR PRODUCTS INCLUDED THEREON;
          (II) THAT USE OF THE SERVICES WILL BE 100% SECURE, UNINTERRUPTED OR ERROR-FREE; (III)
          AS TO THE ACCURACY, RELIABILITY, OR CURRENCY OF ANY INFORMATION, CONTENT, OR SERVICE,
          PROVIDED THROUGH THE SERVICES; OR (IV) THAT THE SERVERS, OR EMAILS SENT FROM OR ON
          BEHALF OF US, ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.
          <br />
          FMTG EXPRESSLY DISCLAIMS ANY AND ALL LIABILITY FOR THE ACTIONS OF ITS USERS OR THE
          CONTENTS OF ANY USER CONTENT.
          <br />
          WE WILL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL OR CONSEQUENTIAL DAMAGES
          ARISING FROM THE USE OF THE SERVICES OR THE PURCHASE OF ANY PRODUCT THEREFROM, EVEN IF
          WE OR SUCH PROVIDER HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. UNDER NO
          CIRCUMSTANCES WILL WE BE LIABLE TO YOU FOR MORE THAN THE AMOUNT YOU HAVE PAID US IN
          THE ONE HUNDRED AND EIGHTY (180) DAYS IMMEDIATELY PRECEDING THE DATE ON WHICH YOU
          FIRST ASSERT ANY SUCH CLAIM, AND IF YOU HAVE NOT PAID ANY AMOUNTS DURING THAT TIME
          PERIOD, YOU ACKNOWLEDGE THAT YOUR SOLE REMEDY IS TO CEASE USING THE SERVICES AND
          TERMINATE YOUR ACCOUNT.
          <br /><br />
          <h5>7. LEGALITY</h5>
          You are subject to all laws of the state(s) and countries in which you reside and from
          which you access the Services and are solely responsible for obeying those laws. You
          agree we cannot be held liable if laws applicable to you restrict or prohibit your
          participation. We make no representations or warranties, implicit or explicit, as to
          your legal right to participate in any Services, contests, sweepstakes or tournaments
          offered through the Services nor will any person affiliated, or claiming affiliation
          with the Services have authority to make any such representations or warranties.
          <br /><br />
          <h5>8. APPLICABLE LAW; JURISDICTION</h5>
          The Services are created and controlled by us in country of Malaysia. As such, the
          laws of Malaysia will govern this Agreement.
          <br /><br />
          Subject to the Binding Arbitration section below, you hereby irrevocably and
          unconditionally consent to submit to the exclusive jurisdiction Malaysian courts for
          any litigation arising out of or relating to use of or purchase made through the
          Services (and agree not to commence any litigation relating thereto except in such
          courts).
          <br /><br />
          <h5>9. INDEMNITY</h5>
          You agree to indemnify and hold FMTG, our subsidiaries and affiliates, and our
          respective officers, agents, partners and employees, harmless from any loss,
          liability, claim, or demand, including reasonable attorneys’ fees, made by any third
          party due to or arising out of your breach of this Agreement and/or any of your
          representations and warranties set forth herein.
          <br /><br />
          <h5>10. SEVERABILITY</h5>
          The provisions of this Agreement are intended to be severable. If for any reason any
          provision of this Agreement will be held invalid or unenforceable in whole or in part
          in any jurisdiction, such provision will, as to such jurisdiction, be ineffective to
          the extent of such invalidity or unenforceability without in any manner affecting the
          validity or enforceability thereof in any other jurisdiction or the remaining
          provisions hereof in any jurisdiction.
          <br /><br />
          <h5>11. ELECTRONIC COMMUNICATIONS</h5>
          When you use the Services or send emails to us, you are communicating with us
          electronically. You consent to receive communications from us electronically. We will
          communicate with you by email or by posting notices through the Services. You agree
          that all agreements, notices, disclosures and other communications that we provide you
          electronically satisfy any legal requirement that such communications be in writing.
          <br /><br />
          <h5>12. OTHER</h5>
          This Agreement is deemed accepted upon any use of any of the Services. Our failure to
          exercise or enforce any right or provision of this Agreement will not operate as a
          waiver of such right or provision. The section titles in this Agreement are for
          convenience only and have no legal or contractual effect.
          <br /><br />
          <h5>13. SUPPORT</h5>
          Subject to the other provisions of this Agreement, we will attempt to help you with
          any queries or problems that you may have with the Services or any of your purchases
          through the Services. To reach our customer support team, please e-mail us at
          breakmycoffee (@) gmail.com. It will expedite your request for assistance by providing
          our representatives with all the information they need to solve your problem as
          quickly as possible.
          <br /><br />
          <h5>14. MODIFICATION</h5>
          We reserve the right to make changes to the Services, posted policies and this
          Agreement at any time without notice other than the reposting of the modified
          Agreement. We will attempt to notify you of material changes by communicating them to
          you directly (if we have contact information for you), adding temporary banners to the
          Services or otherwise highlighting such changes.<br />
          Please contact us at breakmycoffee (@) gmail.com with any questions regarding this
          Agreement.
        </div>
      </section>

      <section class="sp-final">
        <div class="sp-sun"></div>
        <div class="sp-wrap">
          <div class="sp-kicker sp-kicker--center" v-reveal>One email. Every weekday.</div>
          <h2 v-reveal>Wake up<br /><em>already caught up.</em></h2>
          <p v-reveal>Join &gt;24,000 Malaysians. Unsubscribe anytime — no hard feelings.</p>
          <form class="sp-capture sp-capture--center" v-reveal @submit.prevent="subscribeFinal">
            <input
              ref="finalEmail"
              v-model="finalEmail"
              type="email"
              required
              placeholder="you@email.com"
              aria-label="Email address"
            />
            <button class="sp-go" type="submit" :class="{ 'sp-go--ok': finalState === 'done' }">
              <template v-if="finalState === 'brewing'">Brewing… ☕</template>
              <template v-else-if="finalState === 'done'">You're in ✓</template>
              <template v-else>Subscribe <span class="sp-arr">→</span></template>
            </button>
          </form>
          <div class="sp-referral sp-referral--center sp-referral--after" v-reveal>
            <span class="sp-referral-label">Referral code</span>
            <input
              v-model="referral"
              class="sp-referral-input"
              placeholder="Referral code"
              aria-label="Referral code"
            />
          </div>
          <div class="sp-note" v-reveal>Free forever · No spam · 3-minute read</div>
        </div>
        <footer>
          <span>Copyright © 2023 FINLIT MEDIA TECH GROUP SDN BHD (1348643-U)</span>
          <span>Brewed in Kuala&nbsp;Lumpur ☕</span>
          <span>
            <a @click="$router.push('/about')">About</a> ·
            <a href="https://thecoffeebreak.substack.com/archive" target="_blank" rel="noopener">Archive</a> ·
            <a @click="$router.push('/ilovetcb')">Support us</a> ·
            <a @click="$router.push('/privacy-policy')">Privacy Policy</a> ·
            <a @click="$router.push('/terms-of-service')">Terms of Service</a>
          </span>
        </footer>
      </section>
    </main>
  </div>
</template>

<script>
import axios from "axios";

const SUBSCRIBE_URL =
  "https://hukopzhug3.execute-api.ap-southeast-1.amazonaws.com/production/email/submit";

export default {
  name: "TermsOfServiceNew",
  directives: {
    reveal: {
      inserted(el) {
        el.classList.add("sp-reveal");
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
          el.classList.add("sp-in");
          return;
        }
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                el.classList.add("sp-in");
                io.unobserve(el);
              }
            });
          },
          { threshold: 0.1 }
        );
        io.observe(el);
      },
    },
  },
  data() {
    return {
      menuOpen: false,
      scrolled: false,
      scrollProgress: 0,
      finalEmail: "",
      finalState: "idle",
      referral: "",
    };
  },
  mounted() {
    document.title = "Terms of Service — The Coffee Break";
    const urlParams = new URLSearchParams(window.location.search);
    this.referral = urlParams.get("referral") || urlParams.get("ref") || "";
    window.addEventListener("scroll", this.onScroll, { passive: true });
    document.addEventListener("click", this.onDocClick);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
    document.removeEventListener("click", this.onDocClick);
  },
  methods: {
    onScroll() {
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      this.scrollProgress = max > 0 ? (h.scrollTop / max) * 100 : 0;
      this.scrolled = h.scrollTop > 40;
    },
    onDocClick(e) {
      if (this.menuOpen && this.$refs.menuWrap && !this.$refs.menuWrap.contains(e.target)) {
        this.menuOpen = false;
      }
    },
    goto(path) {
      this.menuOpen = false;
      this.$router.push(path);
    },
    focusFinalEmail() {
      this.$refs.finalEmail.scrollIntoView({ behavior: "smooth", block: "center" });
      this.$refs.finalEmail.focus();
    },
    async subscribeFinal() {
      const emailVal = this.finalEmail.trim();
      if (!emailVal) return;
      this.finalState = "brewing";
      try {
        this.$gtag.event("subscribe", {
          event_label: "subscribe_terms_new",
          value: emailVal,
        });
        await axios.post(SUBSCRIBE_URL, { email: emailVal, referral: this.referral.trim() });
        this.finalState = "done";
        this.finalEmail = "";
      } catch {
        this.finalState = "idle";
      }
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,400;12..96,600;12..96,800&family=Instrument+Serif:ital@0;1&family=Roboto+Mono:wght@400;500&display=swap");
</style>

<style scoped>
.sp {
  --paper: #faf7f0;
  --paper-2: #f3eee2;
  --ink: #101820;
  --ink-2: #3d4852;
  --ink-3: #7a8691;
  --blue: #007cb7;
  --blue-deep: #083d73;
  --sky: #e3f2fd;
  --volt: #ffdb00;
  --line: rgba(16, 24, 32, 0.14);
  --serif: "Instrument Serif", Georgia, serif;
  --grotesk: "Bricolage Grotesque", "Helvetica Neue", sans-serif;
  --mono: "Roboto Mono", Menlo, monospace;
  --ease: cubic-bezier(0.16, 1, 0.3, 1);

  font-family: var(--grotesk);
  background: var(--paper);
  color: var(--ink);
  -webkit-font-smoothing: antialiased;
  overflow-x: hidden;
  position: relative;
}
.sp *,
.sp *::before,
.sp *::after {
  box-sizing: border-box;
}
.sp ::selection {
  background: var(--volt);
  color: var(--ink);
}

/* brew bar */
.sp-brew {
  position: fixed;
  top: 0;
  left: 0;
  height: 3px;
  background: var(--blue);
  z-index: 65;
}

/* nav */
.sp-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 32px;
  transition: background 0.3s, box-shadow 0.3s;
}
.sp-scrolled {
  background: rgba(250, 247, 240, 0.92);
  backdrop-filter: blur(12px);
  box-shadow: 0 1px 0 var(--line);
}
.sp-lockup {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  color: var(--ink);
  cursor: pointer;
}
.sp-lockup img {
  height: 30px;
  display: block;
}
.sp-lockup span {
  font-weight: 800;
  font-size: 16px;
  letter-spacing: -0.02em;
}
.sp-nav-actions {
  display: flex;
  align-items: center;
  gap: 14px;
}
.sp-menu-wrap {
  position: relative;
}
.sp-menu-btn {
  font-family: var(--grotesk);
  font-weight: 800;
  font-size: 13px;
  letter-spacing: 0.02em;
  color: var(--ink);
  background: transparent;
  border: 1.5px solid var(--line);
  border-radius: 999px;
  padding: 10.5px 20px;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
}
.sp-menu-btn:hover {
  border-color: var(--blue);
  background: rgba(0, 124, 183, 0.06);
}
.sp-menu-dropdown {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  min-width: 200px;
  background: var(--paper);
  border: 1.5px solid var(--line);
  border-radius: 16px;
  padding: 10px;
  box-shadow: 0 20px 40px rgba(16, 24, 32, 0.14);
  display: none;
  flex-direction: column;
}
.sp-menu-dropdown.sp-menu-open {
  display: flex;
}
.sp-menu-dropdown a {
  font-family: var(--grotesk);
  font-size: 14px;
  font-weight: 600;
  color: var(--ink);
  text-decoration: none;
  padding: 10px 12px;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.sp-menu-dropdown a:hover {
  background: var(--sky);
  color: var(--blue);
}
.sp-heart {
  color: #e5484d;
  vertical-align: -2px;
  margin-right: 4px;
}
/* desktop: list the links inline instead of behind the Menu button */
@media (min-width: 961px) {
  .sp-menu-btn {
    display: none;
  }
  .sp-menu-dropdown {
    position: static;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 2px;
    min-width: 0;
    padding: 0;
    background: transparent;
    border: none;
    box-shadow: none;
  }
  .sp-menu-dropdown a {
    white-space: nowrap;
  }
}
.sp-cta {
  font-family: var(--grotesk);
  font-weight: 800;
  font-size: 13px;
  letter-spacing: 0.02em;
  color: var(--paper);
  background: var(--ink);
  border: none;
  border-radius: 999px;
  padding: 12px 22px;
  cursor: pointer;
  transition: transform 0.3s var(--ease), background 0.3s;
}
.sp-cta:hover {
  background: var(--blue);
  transform: scale(1.05);
}
@media (max-width: 720px) {
  .sp-nav-actions {
    gap: 8px;
  }
  .sp-menu-btn {
    padding: 9px 14px;
    font-size: 12px;
  }
  .sp-cta {
    padding: 10px 16px;
    font-size: 12px;
  }
  .sp-nav {
    padding: 14px 18px;
  }
}
@media (max-width: 420px) {
  .sp-lockup span {
    display: none;
  }
}

/* legal hero */
.ab-legal-hero {
  padding: 150px 0 60px;
}
.sp-kicker {
  font-family: var(--mono);
  font-size: 12px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--ink-3);
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 20px;
}
.sp-kicker::before {
  content: "";
  width: 44px;
  height: 1px;
  background: currentColor;
}
.sp-kicker--center {
  justify-content: center;
}
.sp-display {
  font-weight: 800;
  font-size: clamp(48px, 9vw, 140px);
  line-height: 0.92;
  letter-spacing: -0.04em;
  margin: 0;
  text-transform: uppercase;
}
.sp-row {
  display: block;
  overflow: hidden;
}
.sp-row > span {
  display: inline-block;
  transform: translateY(110%);
  animation: sp-rise 1.1s var(--ease) forwards;
}
.sp-row:nth-child(2) > span {
  animation-delay: 0.12s;
}
@keyframes sp-rise {
  to {
    transform: translateY(0);
  }
}
.sp-display em {
  font-family: var(--serif);
  font-style: italic;
  font-weight: 400;
  text-transform: none;
  letter-spacing: -0.01em;
  color: var(--blue);
}
.sp-cupword {
  position: relative;
  white-space: nowrap;
}
.sp-cupword::after {
  content: "";
  position: absolute;
  left: -2%;
  right: -2%;
  bottom: 6%;
  height: 0.18em;
  background: var(--volt);
  z-index: -1;
  transform: scaleX(0);
  transform-origin: left;
  animation: sp-swipe 0.8s var(--ease) 1s forwards;
}
@keyframes sp-swipe {
  to {
    transform: scaleX(1);
  }
}
@media (max-width: 720px) {
  .ab-legal-hero {
    padding: 120px 0 40px;
  }
}

/* legal article */
.ab-legal {
  padding: 20px 0 100px;
}
.ab-legal-wrap {
  max-width: 780px;
  font-size: 16px;
  line-height: 1.8;
  color: var(--ink-2);
}
.ab-legal-wrap >>> h5 {
  font-family: var(--grotesk);
  font-weight: 800;
  font-size: 20px;
  letter-spacing: -0.01em;
  color: var(--ink);
  margin: 48px 0 16px;
}
.ab-legal-wrap >>> ul {
  margin: 14px 0 20px;
  padding-left: 22px;
}
.ab-legal-wrap >>> li {
  margin-bottom: 10px;
}
.ab-legal-wrap >>> li::marker {
  color: var(--blue);
}
.ab-legal-wrap >>> b {
  color: var(--ink);
  font-weight: 700;
}
@media (max-width: 720px) {
  .ab-legal {
    padding: 8px 0 60px;
  }
  .ab-legal-wrap {
    font-size: 15px;
  }
}

/* shared */
.sp-wrap {
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 32px;
}
@media (max-width: 720px) {
  .sp-wrap {
    padding: 0 18px;
  }
}
.sp-reveal {
  opacity: 0;
  transform: translateY(24px);
  transition: opacity 0.9s var(--ease), transform 0.9s var(--ease);
}
.sp-reveal.sp-in {
  opacity: 1;
  transform: none;
}

.sp-referral {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 16px;
}
.sp-referral--center {
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 8px;
  max-width: 520px;
}
.sp-referral--after {
  margin-top: 20px;
  margin-bottom: 0;
  opacity: 0.75;
}
.sp-referral-label {
  font-family: var(--mono);
  font-size: 11px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--ink-3);
  white-space: nowrap;
}
.sp-referral-input {
  height: 36px;
  padding: 0 16px;
  font-family: var(--grotesk);
  font-size: 13px;
  color: var(--ink);
  background: transparent;
  border: 1.5px solid var(--line);
  border-radius: 999px;
  outline: none;
  flex: 1;
  transition: border-color 0.2s;
}
.sp-referral-input::placeholder {
  color: var(--ink-3);
}
.sp-referral-input:focus {
  border-color: var(--blue);
}
.sp-capture {
  display: flex;
  gap: 10px;
  flex: 1;
  max-width: 520px;
  min-width: 300px;
}
.sp-capture--center {
  margin: 0 auto;
  justify-content: center;
}
.sp-capture input {
  flex: 1;
  line-height: 1;
  padding: 9px 16px;
  font-family: var(--grotesk);
  font-size: 13px;
  color: var(--ink);
  background: transparent;
  border: 1.5px solid var(--line);
  border-radius: 999px;
  outline: none;
  transition: border-color 0.2s, background 0.2s;
}
.sp-capture input::placeholder {
  color: var(--ink-3);
}
.sp-capture input:focus {
  border-color: var(--blue);
  background: #fff;
}
.sp-go {
  height: 36px;
  padding: 0 20px;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  background: var(--blue);
  color: #fff;
  font-family: var(--grotesk);
  font-weight: 800;
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
  transition: background 0.25s;
  position: relative;
}
.sp-go:hover {
  background: var(--blue-deep);
}
.sp-go--ok {
  background: #27ae60;
}
.sp-arr {
  transition: transform 0.3s var(--ease);
  display: inline-block;
}
.sp-go:hover .sp-arr {
  transform: translateX(5px);
}
@media (max-width: 520px) {
  .sp-capture {
    flex-direction: column;
    min-width: 0;
    width: 100%;
  }
  .sp-capture input,
  .sp-go {
    width: 100%;
  }
  .sp-go {
    justify-content: center;
  }
}

/* final CTA */
.sp-final {
  padding: 150px 0 60px;
  text-align: center;
  position: relative;
  overflow: hidden;
}
.sp-sun {
  position: absolute;
  left: 50%;
  bottom: -32vw;
  transform: translateX(-50%);
  width: 64vw;
  height: 64vw;
  border-radius: 50%;
  background: radial-gradient(circle at 50% 30%, var(--sky) 0%, rgba(227, 242, 253, 0) 70%);
  pointer-events: none;
}
.sp-final h2 {
  font-weight: 800;
  font-size: clamp(44px, 8vw, 120px);
  line-height: 0.95;
  letter-spacing: -0.04em;
  text-transform: uppercase;
  margin: 0 0 18px;
  position: relative;
}
.sp-final h2 em {
  font-family: var(--serif);
  font-style: italic;
  font-weight: 400;
  text-transform: none;
  color: var(--blue);
}
.sp-final p {
  font-size: 17px;
  color: var(--ink-2);
  margin: 0 0 44px;
  position: relative;
}
.sp-final .sp-capture {
  margin: 0 auto;
  position: relative;
}
.sp-note {
  margin-top: 18px;
  font-family: var(--mono);
  font-size: 11.5px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--ink-3);
  position: relative;
}

@media (max-width: 720px) {
  .sp-final {
    padding: 90px 0 40px;
  }
  footer {
    margin-top: 64px;
  }
}

footer {
  margin-top: 130px;
  border-top: 1.5px solid var(--ink);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 26px 32px;
  font-family: var(--mono);
  font-size: 11.5px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--ink-3);
  flex-wrap: wrap;
  position: relative;
  background: var(--paper);
}
footer a {
  color: var(--ink);
  text-decoration: none;
  cursor: pointer;
}
footer a:hover {
  color: var(--blue);
}

@media (prefers-reduced-motion: reduce) {
  .sp-row > span {
    animation: none;
    transform: none;
  }
  .sp-cupword::after {
    animation: none;
    transform: scaleX(1);
  }
  .sp-reveal {
    opacity: 1;
    transform: none;
    transition: none;
  }
}
</style>
